import constants from '../constants'
import DoctorLocation from '../containers/AnayaCare/Components/DoctorLocation'
import PatientAddress from '../containers/SemaGlutide/Pages/Onboarding/PatientAddress'
import UploadDocuments from '../containers/SemaGlutide/Pages/Onboarding/UploadDocuments'

export const SEMA_DOCUMENT_TYPES = [
  {
    document_type: 'pi',
    document_title: 'Purchase Invoice',
    button_text: 'Upload Invoice',
    description: `Upload your purchase invoice of the semaglutide medication`,
  },
]

export const SEMA_UPLOAD_DOCUMENTS_STEP = {
  name: 'uploadDocuments',
  hideButton: true,
  hideImage: true,
  bg: '#FFF',
  title: 'Upload documents',
  subTitle: 'Upload your purchase invoice of your Semaglyn medication',
  Component: UploadDocuments,
}

export const SEMA_PATIENT_ADDRESS_STEP = {
  name: 'address',
  hideButton: true,
  hideImage: true,
  title: 'Please enter your address',
  subTitle: 'MySaathi Welcome Kit will be delivered to this address',
  Component: PatientAddress,
}

export const SEMA_ONBOARDING_STEPS = [
  SEMA_UPLOAD_DOCUMENTS_STEP,
  SEMA_PATIENT_ADDRESS_STEP,
]
export const DOCTOR_DETAILS_STEP = {
  name: 'doctorDetails',
  hideButton: true,
  hideImage: true,
  title: 'Please enter your doctor details',
  Component: DoctorLocation,
  withoutAPI: true,
  source: constants.GLP_USER_FROM,
}

export const QR_TYPES = {
  MEDICINE: 'medicine',
  DOCTOR: 'doctor',
}
export const SEMA_REPORT_TYPE = 'pi'
export const SEMAGLYN = 'semaglyn'
export const FERTIGLYN = 'femaglyn'
export const MASHEMA = 'mashema'

export const MYSAATHI_VARIANT_STORAGE_KEY = 'mysaathi_selected_variant'
export const MYSAATHI_VARIANT_EVENT = 'mysaathi:variant-selected'
